import { render, staticRenderFns } from "./ShippingDayAdd.vue?vue&type=template&id=7f58a54a&"
import script from "./ShippingDayAdd.vue?vue&type=script&lang=js&"
export * from "./ShippingDayAdd.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDayAdd.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports